import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const KpiCard = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-sm)',
      padding: 'var(--space-lg)',
      borderRadius: 'var(--radius-lg)',
      border: '1px solid var(--color-border)',
      background: 'var(--color-surface)',
      minHeight: 140,
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <SkeletonText widths={['120px']} lineHeight="14px" />
      <SkeletonCircle size={32} />
    </div>
    <SkeletonText widths={['80px']} lineHeight="32px" />
    <SkeletonText widths={['96px']} lineHeight="12px" />
  </div>
);

const RecentRow = () => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--space-md)',
      padding: 'var(--space-md)',
      borderRadius: 'var(--radius-md)',
      background: 'var(--color-surface-subtle)',
    }}
  >
    <SkeletonCircle size={40} />
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
      <SkeletonText widths={['60%']} lineHeight="16px" />
      <SkeletonText widths={['40%']} lineHeight="12px" />
    </div>
    <SkeletonBox width={80} height={32} borderRadius="999px" />
  </div>
);

const RaskhHomeSkeleton = () => (
  <div
    aria-hidden="true"
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-2xl)',
      padding: 'clamp(1.5rem, 4vw, 3rem)',
      maxWidth: '1080px',
      margin: '0 auto',
    }}
  >
    {/* Hero */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-sm)' }}>
      <SkeletonText widths={['260px']} lineHeight="32px" />
      <SkeletonText widths={['min(440px, 70vw)']} lineHeight="16px" />
    </div>

    {/* KPI grid */}
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: 'var(--space-md)',
      }}
    >
      <KpiCard />
      <KpiCard />
      <KpiCard />
      <KpiCard />
    </div>

    {/* Recent activity */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-md)' }}>
      <SkeletonText widths={['180px']} lineHeight="20px" />
      <RecentRow />
      <RecentRow />
      <RecentRow />
    </div>

    {/* Quick actions */}
    <SkeletonBox height={220} borderRadius="var(--radius-lg)" />
  </div>
);

export default RaskhHomeSkeleton;
